// @flow

import * as React from 'react';
import { connect } from 'react-redux';

import MorphButton from '../../components/MorphButton';
import IconButton from '../../components/IconButton';
import ShoppingCenterFilters from '../common/ShoppingCenterFilters';
import { selectOffice } from '../../state/offices/officesService';
import OfficesFilters from '../common/OfficesFilters';
import { isMobile } from '../../const';

type Props = {
  selectOffice: Function,
  isOfficeSelected: boolean,
  map: React.Node
}

type State = {
  openFilters: boolean,
}

class GenericMapContainer extends React.PureComponent<Props, State> {
  state: State = {
    openFilters: !isMobile,
  };

  render() {
    return (
      <div className="map-container">
        {this.props.map}
        <MorphButton
          isOpened={this.state.openFilters}
          className="search-button"
          icon="far fa-search"
          onClick={() => this.setState({ openFilters: true })}
          onBlur={() => this.setState({ openFilters: false })}
        >
          {
            this.props.isOfficeSelected
              ? (
                <OfficesFilters />
              ) : (
                <ShoppingCenterFilters />
              )
          }
        </MorphButton>
        <div className="bottom-map-button-container">
          <IconButton
            icon="fas fa-building"
            className={`small-button ${this.props.isOfficeSelected ? 'selected' : ''}`}
            onClick={() => this.props.selectOffice(true)}
          />
          <IconButton
            icon="fas fa-store-alt"
            className={`small-button ${!this.props.isOfficeSelected ? 'selected' : ''}`}
            onClick={() => this.props.selectOffice(false)}
          />
        </div>
      </div>
    );
  }
}

export default connect(state => ({
  isOfficeSelected: state.office.isOfficeSelected,
}), { selectOffice })(GenericMapContainer);
